/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_SubtitleInputs */

const en_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here's what's happening with your store.`)
};

const es_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto es lo que está pasando en tu tienda.`)
};

const fr_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voici ce qui se passe sur votre boutique.`)
};

const de_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das passiert gerade in deinem Store.`)
};

const ja_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのストアの最新状況はこちらです。`)
};

const zh_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这里是您店铺的最新动态。`)
};

const ar_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إليك ما يحدث في متجرك.`)
};

const id_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikut perkembangan toko Anda.`)
};

const it_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecco cosa sta succedendo nel tuo negozio.`)
};

const ru_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вот что происходит с вашим магазином.`)
};

const pt_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aqui está o que está acontecendo na sua loja.`)
};

const ko_seller_dashboard_subtitle = /** @type {(inputs: Seller_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어의 최신 현황을 확인하세요.`)
};

/**
* | output |
* | --- |
* | "Here's what's happening with your store." |
*
* @param {Seller_Dashboard_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_subtitle = /** @type {((inputs?: Seller_Dashboard_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_subtitle(inputs)
	if (locale === "es") return es_seller_dashboard_subtitle(inputs)
	if (locale === "fr") return fr_seller_dashboard_subtitle(inputs)
	if (locale === "de") return de_seller_dashboard_subtitle(inputs)
	if (locale === "ja") return ja_seller_dashboard_subtitle(inputs)
	if (locale === "zh") return zh_seller_dashboard_subtitle(inputs)
	if (locale === "ar") return ar_seller_dashboard_subtitle(inputs)
	if (locale === "id") return id_seller_dashboard_subtitle(inputs)
	if (locale === "it") return it_seller_dashboard_subtitle(inputs)
	if (locale === "ru") return ru_seller_dashboard_subtitle(inputs)
	if (locale === "pt") return pt_seller_dashboard_subtitle(inputs)
	return ko_seller_dashboard_subtitle(inputs)
});